<template>
  <div class="ContractReg">
    <div class="page-title">{{ title }}</div>
    <div>
      <el-form
        ref="form"
        label-width="80px"
        class="form-label-80"
        :model="data"
        :rules="rules"
        inline
      >
        <el-row>
          <el-col :span="6">
            <el-form-item label="거래처" prop="customer_name">
              <ACustomerSelector
                v-model="data.customer_name"
                seller
                confirmChange
                @select="handleSelectCustomer"
                @clear="handleClearCustomer"
                @acceptedChange="handleAcceptedChangeCustomer"
                @canceledChange="handleCanceledChangeCustomer"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="우편번호" prop="zipcode">
              <el-input
                v-model="data.zipcode"
                class="zipcode readonly"
                readonly
              />
              &nbsp;
              <el-button @click="popupZipcode(handleCompleteZipcode)"
                >우편번호검색</el-button
              >
            </el-form-item>
          </el-col>
          <el-col :span="13">
            <el-form-item label="도착지" prop="destination">
              <el-input ref="destination" v-model="data.destination" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <el-form-item label="연락처" prop="customer_tel">
              <el-input v-model="data.customer_tel" />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="수주일" prop="contract_date">
              <ADatePicker v-model="data.contract_date" />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="납기일" prop="delivery_date">
              <ADatePicker v-model="data.delivery_date" />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="매출일" prop="sale_date">
              <ADatePicker
                v-model="data.sale_date"
                :disabled="data.status_flag === '0' ? false : true"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="출하방법" prop="delivery_way_flag">
              <ADeliveryWaySelector
                v-model="data.delivery_way_flag"
                @change="handleChangeDeliveryWay"
              />
            </el-form-item>
          </el-col>
          <el-col :span="3" v-if="data.id">
            <el-form-item label="코드" prop="code">
              <el-input v-model="data.code" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-input placeholder="거래처 비고" :value="customerDesc" disabled>
              <template slot="prepend">거래처 비고</template>
            </el-input>
          </el-col>
        </el-row>
      </el-form>
      <el-tabs
        type="card"
        class="mt-default"
        v-model="active_tab"
        @tab-click="handleTabClick"
      >
        <el-tab-pane label="등록" name="1">
          <ATradeTable
            ref="trade"
            :items="data.details"
            :customer="customer"
            :disabled="disabled"
            :showGoods="!isNew"
            :delivery_date="data.delivery_date"
            :delivery_way_flag="data.delivery_way_flag"
            :destination="data.destination"
            :charger="data.charger"
            showSaleOnly
            showField
            showSpecification
            showAddition
            @changedSum="handleChangedSum"
            @updated="handleUpdated"
          />
          <div class="row-splitter pb-default">
            <el-button
              type="primary"
              v-shortkey="['f4']"
              :disabled="isSale || disabled || !has_grant_write"
              :loading="load_button"
              @shortkey.native="handleClickRegister"
              @click="handleClickRegister"
              >{{
                isNew ? $t("button.register") : $t("button.modify")
              }}(F4)</el-button
            >
            <!-- <el-button
              v-show="isAvailProduction"
              @click="handleClickProdunction"
            >생산지시</el-button> -->
            <el-button
              :disabled="disabled || !has_grant_write"
              v-show="!isNew"
              @click="handleCopyRegister"
              >복사 등록</el-button
            >
            <el-button :disabled="disabled" @click="handleClickEstimation"
              >견적가져오기</el-button
            >
            <el-button :disabled="disabled" @click="handleClickImportExcel">
              엑셀등록
              <AHelper type="warning" size="font-size: 12px">
                <el-link :href="templateUrl" download="excel_import_template.xlsx" type="primary">엑셀등록양식 다운로드</el-link>
              </AHelper>
            </el-button>
            <el-button :disabled="disabled" @click="handleClickLibrary"
              >라이브러리</el-button
            >
            <el-button :disabled="disabled" @click="handleClickHistory"
              >발주이력</el-button
            >
            <el-button :disabled="disabled" @click="handleClickClear"
              >초기화</el-button
            >
            <el-button
              v-shortkey="['f8']"
              :disabled="disabled"
              @shortkey.native="handleClickSaveTemp"
              @click="handleClickSaveTemp"
              >{{ $t("button.save_temp") }}(F8)</el-button
            >
            <el-button
              type="danger"
              v-show="!isNew"
              :disabled="isSale || disabled"
              @click="handleClickDelete"
              >{{ $t("button.delete") }}</el-button
            >
            <ACheckboxYN
              v-model="data.direct_sale_flag"
              v-show="isNew"
              :disabled="disabled"
              style="margin-left: 10px"
              prop="direct_sale_flag"
              >매출 등록</ACheckboxYN
            >
            <ACheckboxYN
              prop="emergency_flag"
              v-model="data.emergency_flag"
              v-show="isNew"
              :disabled="disabled"
              >긴급 발주</ACheckboxYN
            >
            <div v-if="isProduction" class="inline pl-default">
              <el-tag type="success">생산등록</el-tag>
            </div>
            <div v-if="isSale" class="inline pl-default">
              <el-tag>매출등록</el-tag>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="수주내역" name="2">
          <ContractHistory
            ref="history"
            v-if="!disabled"
            :customer_id="data.customer_id"
            @selected="handelSelected"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog
      title="견적 가져오기"
      top="10"
      custom-class="form-dialog"
      destroyOnClose
      :close-on-click-modal="false"
      :visible.sync="dialog_estimation_visible"
      :modal="false"
    >
      <EstmationSelectDialog
        v-if="dialog_estimation_visible"
        :data="form_data"
        @completed="handelEstimationSelectCompleted"
        @select="handleSelectEstimation"
      />
    </el-dialog>
    <el-dialog
      title="엑셀등록"
      top="10"
      width="800px"
      custom-class="form-dialog"
      destroyOnClose
      :close-on-click-modal="false"
      :visible.sync="dialog_import_excel"
      :modal="false"
    >
      <GlassContractImport
        v-if="dialog_import_excel"
        @completed="handelGlassContractImportCompleted"
      />
    </el-dialog>
    <el-dialog
      title="생산지시"
      top="10"
      custom-class="form-dialog"
      destroyOnClose
      :close-on-click-modal="false"
      :visible.sync="dialog_production_visible"
      :modal="false"
    >
      <ProductionContractForm
        v-if="dialog_production_visible"
        :data="data"
        @completed="handleClickProdunctionCompleted"
      />
    </el-dialog>
    <el-dialog
      title="라이브러리"
      top="10"
      custom-class="form-dialog"
      destroyOnClose
      :close-on-click-modal="false"
      :visible.sync="dialog_library_visible"
      :modal="false"
    >
      <LibraryDialog
        v-if="dialog_library_visible"
        type_flag="1"
        :data="data.details"
        :has_grant_write="has_grant_write"
        @completed="handelLibraryCompleted"
        @select="handleSelectLibrary"
      />
    </el-dialog>
    <el-dialog
      title="발주이력"
      top="10"
      custom-class="form-dialog"
      destroyOnClose
      :close-on-click-modal="false"
      :visible.sync="dialog_history_visible"
      :modal="false"
    >
      <HistoryDialog
        v-if="dialog_history_visible"
        :type_flag="2"
        :customer_id="data.customer_id"
        :has_grant_write="has_grant_write"
        @completed="handelHistoryCompleted"
        @select="handleSelectHistory"
      />
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { form_container } from "@/common/mixins/form_container";
import { enter_tab } from "@/common/mixins/enter_tab";
import { contract_form } from "@/common/mixins/contract_form";
import { zipcode_search } from "@/common/mixins/zipcode_search";
import { authority_level } from "@/common/mixins/authority_level";
import LibraryDialog from "@/spa/Common/LibraryDialog";
import ContractHistory from "./ContractHistory";
import EstmationSelectDialog from "./EstmationSelectDialog";
import ProductionContractForm from "./ProductionContractForm";
import GlassContractImport from "./GlassContractImport";
import HistoryDialog from "@/spa/Common//HistoryDialog";

export default {
  name: "ContractReg",
  mixins: [
    form_container,
    enter_tab,
    contract_form,
    zipcode_search,
    authority_level,
  ],
  components: {
    LibraryDialog,
    EstmationSelectDialog,
    ContractHistory,
    ProductionContractForm,
    GlassContractImport,
    HistoryDialog,
  },
  data() {
    return {
      dialog_estimation_visible: false,
      dialog_production_visible: false,
      dialog_library_visible: false,
      dialog_import_excel: false,
      visible_history: false,
      active_tab: "1",
      data: undefined,
      dialog_history_visible: false,
      load_button: false,
    };
  },
  computed: {
    ...mapGetters(["table_product", "temp_data"]),
    isEditable: function() {
      //TODO 생산이나 매출로 등록된 건은 편집되지 않아야 한다.
      return true;
    },
    isAvailProduction: function() {
      if (this.isNew) {
        return false;
      }
      if (!this.data.details || this.data.details.length < 1) {
        return false;
      }
      let hasBom = false;
      this.data.details.forEach((d) => {
        let product = this.table_product.find(
          (p) => p.id === d.product_id && p.bom_flag === "Y"
        );
        if (product) {
          hasBom = true;
        }
        if (!hasBom) {
          return false;
        }
      });
      return hasBom;
    },
    has_grant_write() {
      return this.isWriteLevel("contract_reg");
    },
    templateUrl() {
      return "/excel_import_template.xlsx";
    },
  },
  created() {
    if (this.temp_data[this.$options.name]) {
      this.data = Object.assign({}, this.temp_data[this.$options.name]);
      this.customer = this.table_customer.find(
        (c) => c.id === this.data.customer_id
      );
    } else {
      this.data = this.initData();
    }
  },
  methods: {
    doRegister() {
      let data = Object.assign({}, this.data);
      data.price = this.sum;
      data.details = this.getDetails(true);

      this.api.selectContract(data.id).then((res) => {
        if (JSON.stringify(res.data) !== "{}" && res.data.status_flag !== "0") {
          this.notifyError(
            "해당 수주에 대한 매출 정보가 이미 등록되었습니다. 수주 정보를 수정할 수 없습니다."
          );
          return;
        } else {
          data.status_flag = res.data.status_flag;
          let api = this.isNew
            ? this.api.createContract
            : this.api.updateContract;
          let message = this.isNew
            ? this.$t("message.success_create")
            : this.$t("message.success_update");
          this.load_button = true;
          api(data).then((res) => {
            this.load_button = false;
            this.handleResponse(res, message);
            if (res.error !== this.system.noError) {
              return;
            }
            this.data = res.data;
          });
        }
      });
    },
    doDelete() {
      const data = Object.assign({}, this.data);
      this.api.selectContract(data.id).then((res) => {
        if (JSON.stringify(res.data) !== "{}" && res.data.status_flag !== "0") {
          this.notifyError(
            "해당 수주에 대한 매출 정보가 이미 등록되었습니다. 수주 정보를 삭제할 수 없습니다."
          );
          return;
        } else {
          this.api.deleteContract(data).then((res) => {
            this.handleResponse(res, this.$t("message.success_delete"));
            if (res.error === this.system.noError) {
              this.resetData();
            }
          });
        }
      });
    },
    doEstimationSelect() {
      this.dialog_estimation_visible = true;
    },
    handleClickEstimation() {
      this.util.confirm_leave(
        this,
        this.title,
        this.doEstimationSelect,
        "변경사항이 저장되지 않을 수 있습니다. 계속하시겠습니까?"
      );
    },
    handelEstimationSelectCompleted(message) {
      this.dialog_estimation_visible = false;
      if (!message) {
        return;
      }
      this.$notify(message);
    },
    handleSelectEstimation(result) {
      this.dialog_estimation_visible = false;
      if (!result) {
        return;
      }
      result.details.forEach((d) => {
        d.id = 0;
        d.production_flag = "0";
        d.status_flag = "0";
        this.data.details.push(d);
      });
    },
    handleTabClick(tab) {
      if (tab.index !== "1") {
        return;
      }
      this.visible_history = true;
      if (!this.$refs.history) {
        return;
      }
      this.$refs.history.loadData();
    },
    handelSelected(data) {
      this.data = data;
      this.sum = this.data.price;
      this.active_tab = "1";
    },
    handleClickDelete() {
      this.util.confirm_delete(this, this.title, this.doDelete);
    },
    handleClickClear() {
      this.resetData();
    },
    handleResponse(res, success_message) {
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
      this.temp_data[this.$options.name] = null;
      this.util.notify_success(this, this.title, success_message);
    },
    handleClickProdunction() {
      this.dialog_production_visible = true;
    },
    handleClickProdunctionCompleted(update) {
      this.dialog_production_visible = false;
      if (!update) {
        return;
      }
      this.api.selectContract(this.data).then((res) => {
        this.data = res.data;
      });
    },
    /** 임시 저장 */
    handleClickSaveTemp() {
      let data = Object.assign({}, this.data);
      data.price = this.sum;
      data.details = this.getDetails();
      // this.$options.name = 현재 컴포넌트 이름
      this.temp_data[this.$options.name] = data;
    },
    /** 라이브러리 */
    handleClickLibrary() {
      this.data.details = this.getDetails();
      this.dialog_library_visible = true;
    },
    handelLibraryCompleted() {
      this.dialog_library_visible = false;
    },
    handleSelectLibrary(result) {
      this.dialog_library_visible = false;
      result.details.forEach((d) => {
        d.id = 0;
        d.status_flag = "0";
        this.data.details.push(d);
      });
    },
    handleClickImportExcel() {
      this.dialog_import_excel = true;
    },
    handelGlassContractImportCompleted(result) {
      this.dialog_import_excel = false;
      if (!result) {
        return;
      }
      this.data.contract_date = result.contract_date;
      this.data.delivery_date = result.delivery_date;
      result.details.forEach((d) => {
        d.seq = this.data.details.length + 1;
        this.data.details.push(d);
      });
      this.$nextTick(() => {
        this.$refs.trade.resetGlassItems();
      });
    },
    handleClearCustomer() {
      this.customer = null;
      this.data = this.initData();
    },
    handleAcceptedChangeCustomer(param) {
      this.handleClearCustomer();
      /**
       * ERP-422 수주 등록 페이지 거래처 변경 처리
       * 기존 정보 초기화 후, 변경된 거래처 정보 표시
       */
      this.handleSelectCustomer(param);
    },
    handleCanceledChangeCustomer(param) {
      /**
       * ERP-422 수주 등록 페이지 거래처 변경 처리
       * 입력한 거래처 이름 표시
       */
      this.data.customer_id = param.id;
      this.data.org_customer_id = param.id;
      this.data.customer_name = param.name;
      this.data.customer_tel = param.tel;
      this.data.zipcode = this.util.getCustomerZipcode(param);
      this.data.destination = this.util.getCustomerAddress(param);

      this.EventBus.$emit("changeCostByCustomer", param);
    },
    /**
     * ERP-562 수주시 발주건 조회 등록
     * 발주 이력 조회 다이얼로그
     */
    handleClickHistory() {
      this.data.details = this.getDetails();
      this.dialog_history_visible = true;
    },
    handelHistoryCompleted() {
      this.dialog_history_visible = false;
    },
    handleSelectHistory(result) {
      this.dialog_history_visible = false;
      result.details.forEach((d) => {
        d.id = 0;
        this.data.details.push(d);
      });
    },
    handleCopyRegister() {
      this.data.id = 0;
      this.data.code = "";
      this.data.details.forEach((item) => {
        item.id = null;
        item.contract_id = null;
        item.status_flag = "0";
        item.fix_amount = 0;
        item.production_flag = "0";
      });
      this.data.status_flag = "0";
      delete this.data.created_user_id;
    },
  },
};
</script>
